import * as Api from "@modules/api";
import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";

import { store } from "../store";
import {
  getFaqCategoriesAsync,
  getFaqsByCategoryIdAsync,
  createFaqEngagementAsync,
} from "./slices";

export const getFaqCategories = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getFaqCategoriesAsync());

  return handleDispatchResult(res, onSuccess);
};

export const getFaqsByCategoryId = async (
  body: {
    Id: number;
    PageNumber: number;
    PageSize: number;
  },
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getFaqsByCategoryIdAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const createFaqEngagement = async (
  body: Api.Server.UserFaqEngagementInput,
  onFailure?: () => void | Promise<void>,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(createFaqEngagementAsync(body));

  return handleDispatchResult(res, onSuccess, onFailure);
};
